function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import regeneratorRuntime from "regenerator-runtime";
import { defineComponent, ref } from "vue";
import { batchBtnOption } from "../index";
import { OperationStatus } from "../index";
import { definePropType } from "@types-vue/props";
import { noSupportedAudit, noSupportedEditTags } from "../index";
import BatchOperation from "./batch-operation.vue";
import _ from "lodash";
export default defineComponent({
    components: {
        BatchOperation: BatchOperation
    },
    props: {
        checkedRow: {
            type: definePropType(Array),
            default: function() {
                return [];
            }
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var ids = ref([]);
        var operationType = ref("");
        var dialogVisible = ref(false);
        var handleBatchClick = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(btn) {
                var tableIds;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            tableIds = _.map(props.checkedRow, "id");
                            if (!(btn.value === OperationStatus.delete)) {
                                _ctx.next = 5;
                                break;
                            }
                            {
                                emit("handleBatchDelete", tableIds);
                            }
                            _ctx.next = 16;
                            break;
                        case 5:
                            if (!(btn.value === OperationStatus.audit)) {
                                _ctx.next = 10;
                                break;
                            }
                            if (!noSupportedAudit(props.checkedRow)) {
                                _ctx.next = 8;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 8:
                            _ctx.next = 13;
                            break;
                        case 10:
                            if (!(btn.value === OperationStatus.tags)) {
                                _ctx.next = 13;
                                break;
                            }
                            if (!noSupportedEditTags(props.checkedRow)) {
                                _ctx.next = 13;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 13:
                            ids.value = tableIds;
                            operationType.value = String(btn.value);
                            dialogVisible.value = true;
                        case 16:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function handleBatchClick(btn) {
                return _ref.apply(this, arguments);
            };
        }();
        return {
            ids: ids,
            operationType: operationType,
            dialogVisible: dialogVisible,
            batchBtnOption: batchBtnOption,
            handleBatchClick: handleBatchClick
        };
    }
});
